
export default {
    strict: true,
    namespaced: true,
    state: {
        addresses: null,
        formSchema: null,
        formErrors: null,
        initialFields: null,
        suggestedAddresses: null,
        // this is not the selected suggestion by default,
        // it is a pre-validated suggestion to submit when user cancels/closes validation modal
        suggestedDefault: null,
    },
    mutations: {
        // addresses(state, payload) { 
        //     state.addresses = payload;
        // },
        // formSchema(state, payload) { 
        //     state.formSchema = payload;
        // },
        // formErrors(state, payload) { 
        //     state.formErrors = payload;
        // },
        // initialFields(state, payload) { 
        //     state.initialFields = payload;
        // },
        // suggestedAddresses(state, payload) { 
        //     state.suggestedAddresses = payload;
        // },
        suggestedDefault(state, payload) { 
            state.suggestedDefault = payload;
        },
    },
    actions: {
        // addresses(context, payload) {
        //     context.commit('addresses', payload);
        // },
        // formSchema(context, payload) {
        //     context.commit('formSchema', payload);
        // },
        // formErrors(context, payload) {
        //     context.commit('formErrors', payload);
        // },
        // initialFields(context, payload) {
        //     context.commit('initialFields', payload);
        // },
        // suggestedAddresses(context, payload) {
        //     context.commit('suggestedAddresses', payload);
        // },
        suggestedDefault(context, payload) {
            context.commit('suggestedDefault', payload);
        },
        setFormInfo(context, payload) {
            // context.commit('formSchema', payload.formSchema);
            // context.commit('formErrors', payload.formErrors);
            // context.commit('initialFields', payload.initialFields);
            // context.commit('suggestedAddresses', payload.suggestedAddresses);
            context.commit('suggestedDefault', payload.suggestedDefault);
        },
    },
    getters: {
        // addresses: state => state.addresses,
        // formSchema: state => state.formSchema,
        // formErrors: state => state.formErrors,
        // initialFields: state => state.initialFields,
        // suggestedAddresses: state => state.suggestedAddresses,
        suggestedDefault: state => state.suggestedDefault,
    },
};
